export const PALETTE = {
  board: 0x0c1218,
  boardInner: 0x0a1016,
  boardEdge: 0xe0b85c,
  boardEdgeDeep: 0x8a5e20,
  grid: 0xb8944a,
  cell: 0x10161e,
  block: 0x141820,
  blockTop: 0x222830,
  blockEdge: 0xe0b85c,
  gem: 0x4ad4ea,
  orange: 0xff7a18,
  orangeDeep: 0xa33b00,
  orangeHot: 0xffd19a,
  turquoise: 0x2ad4dc,
  turquoiseDeep: 0x0a6f78,
  turquoiseHot: 0xd9ffff,
  gold: 0xf2cc58,
  goldHot: 0xfff4bc,
  goldDeep: 0x8a5610,
  white: 0xffffff,
  stun: 0x8a9098,
  preview: 0xe8c36a,
  shadow: 0x000000,
  lightning: 0xfff6c8,
} as const;

export function campColor(camp: 'ORANGE' | 'TURQUOISE', deep = false): number {
  if (camp === 'ORANGE') return deep ? PALETTE.orangeDeep : PALETTE.orange;
  return deep ? PALETTE.turquoiseDeep : PALETTE.turquoise;
}

export function campHot(camp: 'ORANGE' | 'TURQUOISE'): number {
  return camp === 'ORANGE' ? PALETTE.orangeHot : PALETTE.turquoiseHot;
}
